import React from 'react';
import {
  FormControl as MuiFormControl,
  Input as MuiInput,
  InputLabel as MuiLabel,
  FormHelperText as MuiFormHelperText,
} from '@material-ui/core';
import { useField } from 'formik';
import styled from 'styled-components';

const Label = styled(MuiLabel)`
  color: white;
  font-size: 1rem;

  &.Mui-focused {
    color: white;
  }
`;

const Input = styled(MuiInput)`
  background: white;
  border-radius: 5px;
  padding-left: 0.5rem;
`;

const FormHelperText = styled(MuiFormHelperText)`
  color: white;
  font-size: 0.75rem;
`;

const Field = ({ ...props }) => {
  const [field, meta] = useField(props);
  return (
    <MuiFormControl
      focused
      fullWidth
      variant="standard"
      error={Boolean(meta.touched && meta.error)}
    >
      <Label htmlFor="Input" shrink>
        Email address
      </Label>

      <Input
        id="Input"
        aria-describedby="input-helper-text"
        name={field.name}
        value={field.value}
        fullWidth
        placeholder="Sign-up"
        disableUnderline
        {...props}
      />

      <FormHelperText id="input-helper-text">
        {meta.touched && meta.error
          ? meta.error
          : "We'll never share your email."}
      </FormHelperText>
    </MuiFormControl>
  );
};

export default Field;
